@if(utilService.loading){
<div class="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-20 z-[1000]">
    <span class="loader"></span>
</div>
}